export default __webpack_public_path__ + "static/media/PowellCatLocation-18.eccaef2e.jpg";